import React, { useEffect, useState } from "react";
import axios from "axios";

const GenerateActionCardModal = ({ isOpen, onClose, onSubmit }) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
   const [machineData, setMachineData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
   const [isLoading, setIsLoading] = useState(false);
const [form, setForm] = useState({
  machine: "",   // instead of vessel
  cardName: "",
  condition: "",
  equipment: "",
});

useEffect(() => {
  if (isOpen) {
    fetchMachine();
  }
}, [isOpen]);

  if (!isOpen) return null;
  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validate = () => {
    const e = {};
  if (!form.machine) e.machine = "Machine is required";
    if (!form.cardName.trim()) e.cardName = "Card name is required";
    return e;
  };
const fetchMachine = async () => {
    try {
       setIsLoading(true);
      const response = await fetch("https://api.hanoch.in/api/machines", {
        // headers: {
        //   "Content-Type": "application/json",
        //   Authorization: `Bearer ${authToken}`, 
        // },
      });

      if (response.ok) {
        const data = await response.json();
        
        setMachineData(data?.data);
      } else if (response.status === 401) {
      
        localStorage.removeItem("authUser");
        localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
     } finally {
      setIsLoading(false);
    }
  };

  
  
  const handleCreate = async () => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    try {
      setLoading(true);

      const payload = {
       machine: form.machine,
        cardname: form.cardName,
        condition: form.condition,
        equipment: form.equipment,
      };

      await axios.post(
        "https://api.hanoch.in/performance/action-cards/",
        payload
      );

      onSubmit?.(payload);
      handleClose();
    } catch (err) {
      console.error(err);
      alert("Failed to create action card");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setForm({
  machine: "",
  cardName: "",
  condition: "",
  equipment: "",
});
    setErrors({});
    onClose();
  };

  // 🎨 styles
  const S = {
    overlay: {
      position: "absolute",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 200,
    },
    modal: {
      background: "#fff",
      borderRadius: 10,
      width: "100%",
      maxWidth: 620,
      border: "0.5px solid #e2e4e8",
      overflow: "hidden",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: "16px 20px",
      borderBottom: "0.5px solid #e2e4e8",
    },
    title: { fontSize: 15, fontWeight: 500 },
    closeBtn: {
      background: "none",
      border: "none",
      cursor: "pointer",
      fontSize: 18,
    },
    body: { padding: "20px" },
    footer: {
      display: "flex",
      justifyContent: "flex-end",
      gap: 10,
      padding: "14px 20px",
      borderTop: "0.5px solid #e2e4e8",
    },
    label: { fontSize: 13, marginBottom: 6, display: "block" },
    field: { marginBottom: 16 },
    input: (err) => ({
      width: "100%",
      height: 38,
      padding: "0 12px",
      border: `1px solid ${err ? "red" : "#ccc"}`,
      borderRadius: 6,
    }),
    textarea: {
      width: "100%",
      minHeight: 80,
      padding: 10,
      borderRadius: 6,
      border: "1px solid #ccc",
    },
    select: {
      width: "100%",
      height: 38,
      padding: "0 12px",
      borderRadius: 6,
      border: "1px solid #ccc",
    },
    error: { color: "red", fontSize: 12 },
    btn: {
      padding: "8px 16px",
      borderRadius: 6,
      cursor: "pointer",
    },
    createBtn: {
      background: "#1a9e78",
      color: "#fff",
      border: "none",
    },
    cancelBtn: {
      background: "#eee",
      border: "none",
    },
  };

  return (
    <div style={S.overlay}>
      <div style={S.modal}>
        {/* Header */}
        <div style={S.header}>
          <span style={S.title}>Generate Action Card</span>
          <button style={S.closeBtn} onClick={handleClose}>
            ✕
          </button>
        </div>

        {/* Body */}
        <div style={S.body}>
          {/* Vessel */}
          <div style={S.field}>
            <label style={S.label}>Machine *</label>
             <select
  style={S.select}
  value={form.machine}
  onChange={(e) => handleChange("machine", e.target.value)}
>
  <option value="">Select Machine</option>
  {machineData?.map((m) => (
    <option key={m.id} value={m.id}>
      {m.name}
    </option>
  ))}
</select>
          </div>

          {/* Card Name */}
          <div style={S.field}>
            <label style={S.label}>Card Name *</label>
            <input
              style={S.input(errors.cardName)}
              value={form.cardName}
              onChange={(e) => handleChange("cardName", e.target.value)}
            />
            {errors.cardName && (
              <div style={S.error}>{errors.cardName}</div>
            )}
          </div>

          {/* Condition */}
          <div style={S.field}>
            <label style={S.label}>Condition</label>
            <textarea
              style={S.textarea}
              value={form.condition}
              onMachineChange={(e) => handleChange("condition", e.target.value)}
            />
          </div>

          {/* Equipment */}
          <div style={S.field}>
            <label style={S.label}>Sub Equipment</label>
            <input
              style={S.input(errors.equipment)}
              value={form.equipment}
              onChange={(e) => handleChange("equipment", e.target.value)}
            />
            {errors.equipment && (
              <div style={S.error}>{errors.equipment}</div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div style={S.footer}>
          <button style={{ ...S.btn, ...S.cancelBtn }} onClick={handleClose}>
            Cancel
          </button>

          <button
            style={{ ...S.btn, ...S.createBtn }}
            onClick={handleCreate}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GenerateActionCardModal;